export const API_BASE_URL = 'https://api.sexagogo.be/api'
export const BASE_URL = 'https://api.sexagogo.be'
export const WEBSITE_URL = 'https://www.sexagogo.be'
export const COMPANY_NAME = 'PointQueudalle SPRL'
export const COMPANY_EMAIL = 'support@sexagogo.de'
export const COMPANY_ADDRESS = 'Avenue des Technologies 123'
export const COMPANY_CITY = '1000 Bruxelles'
export const COMPANY_TVA = 'BE 0123 456 789'
export const X_API_KEY = 'kFKo5OIeLHJ9HBp0Yd9HDpCLZ-qmKLxf'

export const MEILISEARCH_CONFIG = {
  host: 'https://search.sexagogo.be',
  apiKey: 'ZVg80xjJUplawkdYyF2JxNhd0BH9fgnfk4iA5tGI88I',
}
